<template>
    <div id="ad001">
        <div class="top_part">
            <img class="top-back-img" src="@/assets/down-ad/ad001/1.png" alt="">
            <div class="button_box">
                <button @click="iosDown">iOS 下载</button>
                <!-- style="background: #333333; color: #9598A6;"  -->
                <button @click="androidDown">Android 下载</button>
            </div>
        </div>
        <div class="middle-part">
            <img src="@/assets/down-ad/ad001/2.png" alt="">
        </div>
        <div class="bottom-part">
            <img src="@/assets/down-ad/ad001/3.png" alt="">
        </div>
        <div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
            <span class="mask-tip">请在浏览器中打开</span>
            <img src="@/assets/down/tip_arrow.png"/>
        </div>
        <jgz-loading :loading-show='showLoading'></jgz-loading>
    </div>
</template>

<script>
import JgzLoading from '@/components/JgzLoading.vue'
export default {
    name: 'ProDownload01',
    data() {
        return {
            showLoading: true,
            maskViewShow: false,
            iosUrl: '',
            androidUrl: '',
        }
    },
    components: {
        JgzLoading,
    },
    mounted() {
        this.getDownUrl();
    },
    watch: {
        // $route() {
        //     if (window._czc) {
        //         let location = window.location
        //         let contentUrl = location.pathname + location.hash
        //         let refererUrl = '/'
        //         window._czc.push(['_trackPageview', contentUrl, refererUrl])
        //     }
        // }
    },
    methods: {
        getDownUrl() {
            this.$MyAxios.get('/api/versions/downloadUrl', {}, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    this.iosUrl = response.data.ios;
                    this.androidUrl = response.data.android;
                }
            }, error => {
                this.showLoading = false
                alert('请求出错...')
            })
        },

        androidDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
				var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = "javascript: '<script>location.href=\"" + this.androidUrl + "\"<\/script>'"; 
                // let url = "https://test.misc.jinguozi.net/JGZ.apk"
				// iframe.src = "javascript: '<script>location.href=\"" + url + "\"<\/script>'";
				document.getElementsByTagName('body')[0].appendChild(iframe);
			}
        },

        iosDown() {
            let isWeChat =  /MicroMessenger/.test(navigator.userAgent);
			if(isWeChat){
				this.maskViewShow = true;
			}else{
                // window.location.href = `https://testflight.apple.com/join/TO7aMQTq`;
                window.location.href = `${window.location.origin}/user-guide`
            }
        }
    }
}
</script>

<style lang='less'>
#ad001 {
	height: auto;
	width: 100vw;
	background: #111125;;
	// padding-top: 38px;
	background-size: 100% 100%;
	background-repeat: no-repeat;
    position: relative;
    img {
        pointer-events: none;
    }
    .top_part {
        width: 100vw;
        height: 1149px;
        position: relative;
        .top-back-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100vw;
        }
        .button_box {
            width: 100vw;
            position: absolute;
            bottom: 140px;
            left: 0;
        }
        button {
            height: 90px;
            width: 270px;
            outline: none;
            border: none;
            cursor: pointer;
            border-radius: 45px;
            background: #FFA41F;
            box-shadow:0px 6px 16px rgba(255,102,0,0.3);
            position: absolute;
            color: #ffffff;
            font-size: 32px;
            font-weight: bold;
            &:nth-of-type(1) {
                left: 80px;
            }
            &:nth-of-type(2) {
                right: 80px;
            }
            // &:nth-of-type(3) {
            //     top: 554px;
            // }
        }
    }
    .middle-part {
        img {
            width: 100vw;
        }
    }
    .bottom-part {
        img {
            width: 100vw;
        }
    }
}
</style>
